<template>
    <div></div>
</template>
<script>
import { globals } from "../../main";
import {
    mapGetters, mapActions
} from "vuex";
export default {
    data() {
        return {
            slug: this.$route.params.slug
        };
    },
    computed: {
        ...mapGetters([
            "clientIdentifierResponse",
            "consumerCartUpdateResponse"
        ]),
    },

    watch: {

        consumerCartUpdateResponse: function (data) {
            this.$router.replace({
                name: 'plans'
            })
        },

        clientIdentifierResponse: function (data) {

            if (this.$helper.isLoggedIn()) {
                this.consumerCartUpdate({})
            } else {
                this.$router.replace({
                    name: 'plans'
                })
            }
        },
    },

    mounted() {
        globals.$loader.show();
        this.setRedirections()
    },

    methods: {
        ...mapActions([
            "consumerCartUpdate",
            "updateClientIdentifier"]),

        setRedirections() {
            if (this.slug == 'cart-added') {
                if (this.$route.query.is_shared_url == 1) {
                    this.setIdentifier()
                } else {
                    this.$router.replace({
                        name: 'plans'
                    })
                }
            }
        },

        setIdentifier() {
           
            // let oldIdentifier = localStorage.getItem("client_identifier") ?? ''
            // if (this.$route.query.identifier != oldIdentifier) {
              //  localStorage.setItem("client_identifier", this.$route.query.identifier)
                this.updateClientIdentifier({
                    client_identifier:  this.$route.query.identifier//oldIdentifier
                })
            // } else {
            //     this.$router.replace({
            //         name: 'plans'
            //     })
            // }

        },
    }
}
</script>